// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a26c98d4","455":"ee03c0be","977":"d649f8bf"}[chunkId] + ".chunk.js";
};